/* Puff Land – script chargé par les sections concernées (dépend de theme.js) */
(() => {
  'use strict';
  const PL = window.PL;
  if (!PL || !PL.u || PL.loaded_guides) return;
  PL.loaded_guides = true;
  const { $, $$, debounce, parseHTML, storage, formatMoney, toast, trapFocus, esc, norm, num, fill, fetchProductData, productDataUrl, productBase, starsHTML, buyButton, isDesktop, reduceMotion, initWishlistButtons, applyDiscountCode, getCart, refreshCart } = PL.u;
  const S = PL.strings;
  const R = PL.routes;
  const Cart = PL.cart;
  const Compare = PL.compare;

  /* ---------- Guide Puff Land : filtre par thème ---------- */
  class GuidesFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-guide-filter]');
        if (!pill) return;
        const tag = pill.dataset.guideFilter;
        if (PL.u.moreReset) PL.u.moreReset(this);
        $$('[data-guide-filter]', this).forEach((p) => { const on = p === pill; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        let shown = 0;
        $$('[data-guides-grid] > li', this).forEach((li) => {
          const ok = tag === '*' || (li.dataset.tags || '').split(' ').includes(tag);
          li.hidden = !ok; if (ok) shown += 1;
        });
        const empty = $('[data-guides-empty]', this);
        if (empty) empty.hidden = shown > 0;
        // Grille sans case vide : la 1re carte visible devient la vedette, la dernière peut s'élargir (section-guides.css)
        const grid = $('[data-guides-grid]', this);
        const cards = $$('[data-guides-grid] > li', this);
        const visible = cards.filter((li) => !li.hidden);
        cards.forEach((li) => li.classList.remove('guide-card--featured', 'is-last'));
        if (visible.length) { visible[0].classList.add('guide-card--featured'); visible[visible.length - 1].classList.add('is-last'); }
        if (grid) grid.dataset.n = String(visible.length);
      });
      // Lien depuis un article (?theme=nicotine) : le thème est présélectionné
      const want = new URLSearchParams(location.search).get('theme');
      const pill = want && $(`[data-guide-filter="${CSS.escape(want)}"]`, this);
      if (pill) pill.click();
    }
  }
  if (!customElements.get('guides-filter')) customElements.define('guides-filter', GuidesFilter);
})();
